import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ResponsiveContext, Button, Layer, TextInput, Box, Select, Anchor } from 'grommet';
import { FormClose } from 'grommet-icons';

import { TitleField, CalendarDropButton, SelectSearch } from '../../../../components/form';
import { TitleDetail } from '../../../../components/detail';

import { searchExpenses, clearFieldsFormSearch, hideLayer, setDefaultPageRules } from '../../actions/form-search';
import { changeValues } from '../../../../actions/form';

import paginationDefault from '../../../../constants/pagination';
import visibleWidth from '../../../../constants/layer-width';

import { formattedDateTime } from '../../../../utils';

import selectExpenseCategory from '../../../../constants/select-expense-category';
import selectExpenseStatusOptions from '../../../../constants/select-expense-status';
import selectYesNoOptions from '../../../../constants/select-yesno-options';

import TYPES from '../../actions/types';

class FormSearch extends Component {
  searchAndSetPagination = formParams => {
    const { searchExpenses, hideLayer, setDefaultPageRules } = this.props;

    setDefaultPageRules();
    searchExpenses(formParams);
    hideLayer();
  };

  render() {
    const {
      reference,
      categoryId,
      statusId,
      startDateExpense,
      endDateExpense,
      recipient,
      isRefund,
      toggleLayer,

      hideLayer,
      clearFieldsFormSearch,
      changeValues,
    } = this.props;

    if(toggleLayer && toggleLayer === 'search') {
      return (
        <ResponsiveContext.Consumer>
          {size => (
            <Layer
              responsive={false}
              full='vertical'
              position='left'
              onClickOutside={hideLayer}
              onEsc={hideLayer}
            >
              <Box
                fill='vertical'
                width={visibleWidth[size]}
                pad={{ top: 'large', bottom: 'xsmall' }}
                overflow='auto'
                flex
              >
                <Box
                  direction='row'
                  justify='between'
                  align='baseline'
                  margin={{ horizontal: 'large' }}
                >
                  <TitleDetail value='Filtrar' />

                  <Button
                    plain
                    title='Fechar'
                    icon={<FormClose />}
                    onClick={hideLayer}
                  />
                </Box>


                <Box flex overflow='auto'>
                  {/* Referência/Reembolso */}
                  <Box
                    margin={{
                      vertical: size === 'small' ? 'medium' : 'small',
                      horizontal: 'large'
                    }}
                    flex={{ shrink: 0 }}
                  >
                    <Box
                      direction='row'
                      gap='small'
                    >
                      <Box width='large'>
                        <TitleField text='Referência' />

                        <TextInput
                          value={reference ?? ''}
                          onChange={event =>
                            changeValues(
                              {fieldName: 'reference', value: event.target.value }, TYPES.changeFormSearchField
                            )
                          }
                        />
                      </Box>

                      <Box width='large'>
                        <Box direction='row' align='center' gap='xsmall'>
                          <TitleField text='Reembolso' />

                          {isRefund != null && (<Anchor
                            size='small'
                            label='limpar'
                            onClick={() =>
                              changeValues(
                                {fieldName: 'isRefund', value: null }, TYPES.changeFormSearchField
                              )
                            }
                          />)}
                        </Box>

                        <SelectSearch
                          options={selectYesNoOptions}
                          labelKey='name'
                          valueKey={{ key: 'id', reduce: true }}
                          value={isRefund ?? ''}
                          emptySearchMessage='Selecione uma opção'
                          onChange={({ value: nextValue }) =>
                            changeValues(
                              {fieldName: 'isRefund', value: nextValue }, TYPES.changeFormSearchField
                            )
                          }
                        />
                      </Box>
                    </Box>
                  </Box>


                  {/* Categoria/Status */}
                  <Box
                    margin={{
                      vertical: size === 'small' ? 'medium' : 'small',
                      horizontal: 'large'
                    }}
                    flex={{ shrink: 0 }}
                  >
                    <Box
                      direction='row'
                      gap='small'
                    >
                      <Box width='large'>
                        <Box direction='row' align='center' gap='xsmall'>
                          <TitleField text='Categoria' />

                          {categoryId && (<Anchor
                            size='small'
                            label='limpar'
                            onClick={() =>
                              changeValues(
                                {fieldName: 'categoryId', value: null }, TYPES.changeFormSearchField
                              )
                            }
                          />)}
                        </Box>

                        <Select
                          options={selectExpenseCategory}
                          labelKey='name'
                          valueKey={{ key: 'id', reduce: true }}
                          value={categoryId ?? ''}
                          emptySearchMessage='Selecione uma opção'
                          onChange={({ value: nextValue }) =>
                            changeValues(
                              {fieldName: 'categoryId', value: nextValue }, TYPES.changeFormSearchField
                            )
                          }
                        />
                      </Box>

                      <Box width='large'>
                        <Box direction='row' align='center' gap='xsmall'>
                          <TitleField text='Status' />

                          {statusId && (<Anchor
                            size='small'
                            label='limpar'
                            onClick={() =>
                              changeValues(
                                {fieldName: 'statusId', value: null }, TYPES.changeFormSearchField
                              )
                            }
                          />)}
                        </Box>

                        <Select
                          options={selectExpenseStatusOptions}
                          labelKey='name'
                          valueKey={{ key: 'id', reduce: true }}
                          value={statusId ?? ''}
                          emptySearchMessage='Selecione uma opção'
                          onChange={({ value: nextValue }) =>
                            changeValues(
                              {fieldName: 'statusId', value: nextValue }, TYPES.changeFormSearchField
                            )
                          }
                        />
                      </Box>
                    </Box>
                  </Box>

                  {/* Data despesa */}
                  <Box
                    margin={{
                      vertical: size === 'small' ? 'medium' : 'small',
                      horizontal: 'large'
                    }}
                    flex={{ shrink: 0 }}
                  >
                    <TitleField text='Data da despesa' />

                    <Box
                      direction='row'
                      gap='small'
                    >
                      <CalendarDropButton
                        date={startDateExpense ?? ''}
                        onSelect={(selectedDate) =>
                          changeValues(
                            {fieldName: 'startDateExpense', value: selectedDate }, TYPES.changeFormSearchField
                          )
                        }
                      />

                      <CalendarDropButton
                        date={endDateExpense ?? ''}
                        onSelect={(selectedDate) =>
                          changeValues(
                            {fieldName: 'endDateExpense', value: selectedDate }, TYPES.changeFormSearchField
                          )
                        }
                      />
                    </Box>
                  </Box>

                  {/* Nome */}
                  <Box
                    margin={{
                      vertical: size === 'small' ? 'medium' : 'small',
                      horizontal: 'large'
                    }}
                    flex={{ shrink: 0 }}
                  >
                    <TitleField text='Nome' />

                    <TextInput
                      value={recipient ?? ''}
                      onChange={event =>
                        changeValues(
                          {fieldName: 'recipient', value: event.target.value }, TYPES.changeFormSearchField
                        )
                      }
                    />
                  </Box>
                </Box>

                <Box
                  direction='row'
                  pad={{ vertical: 'medium' }}
                  margin={{ horizontal: 'large' }}
                  justify='center'
                  align='center'
                  gap='small'
                >
                  <Box width='small'>
                    <Button
                      color='dark-3'
                      label='Limpar'
                      onClick={() => clearFieldsFormSearch()}
                    />
                  </Box>

                  <Box width='small'>
                    <Button
                      color='brand'
                      primary
                      label='Buscar'
                      onClick={() =>
                        this.searchAndSetPagination({
                          reference,
                          categoryId,
                          statusId,
                          startDateExpense: formattedDateTime(startDateExpense),
                          endDateExpense: formattedDateTime(endDateExpense),
                          recipient,
                          isRefund,
                          page: paginationDefault.page,
                          limit: paginationDefault.limit,
                        })
                      }
                    />
                  </Box>
                </Box>
              </Box>
            </Layer>
          )}
        </ResponsiveContext.Consumer>
      )
    }

    return null;
  }
}

const mapStateToProps = ({ expenseReducer: { formSearch }, layerReducer }) => ({
  reference: formSearch.reference,
  categoryId: formSearch.categoryId,
  statusId: formSearch.statusId,
  startDateExpense: formSearch.startDateExpense,
  endDateExpense: formSearch.endDateExpense,
  recipient: formSearch.recipient,
  isRefund: formSearch.isRefund,

  toggleLayer: layerReducer.toggleLayer,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    searchExpenses,
    clearFieldsFormSearch,
    setDefaultPageRules,
    hideLayer,
    changeValues,
  }, dispatch);

export const Search = connect(mapStateToProps, mapDispatchToProps)(FormSearch);
